import { endpointConstants } from "../constants";
import { get, post } from "../../utils/yodaHttpRequest";

export const yodaIdentityService = {
  getOne,
  getCustomers,
  getDoors,
  getAddresses,
  getLines,
  getOrderConfigurations,
  getColors,
};

function getOne(uuid) {
  let endpoint = endpointConstants.YODAIDENTITY.GET_ONE.replace(":uuid", uuid);
  return get(endpoint);
}

function getCustomers(uuid) {
  let endpoint = endpointConstants.YODAIDENTITY.GET_CUSTOMERS.replace(
    ":uuid",
    uuid,
  );
  return post(endpoint, {});
}

function getDoors(customerId) {
  let endpoint = endpointConstants.YODAIDENTITY.GET_DOORS.replace(
    ":customerId",
    customerId,
  );
  return get(endpoint);
}

function getAddresses(customerId) {
  let endpoint = endpointConstants.YODAIDENTITY.GET_ADDRESSES.replace(
    ":customerId",
    customerId,
  );
  return get(endpoint);
}

function getLines(customerId) {
  let endpoint = endpointConstants.YODAIDENTITY.GET_LINES.replace(
    ":customerId",
    customerId,
  );
  return get(endpoint);
}

function getOrderConfigurations(customerId, agentId) {
  let endpoint =
    endpointConstants.YODAIDENTITY.GET_ORDER_CONFIGURATIONS.replace(
      ":customerId",
      customerId,
    ).replace(":agentId", agentId);
  return get(endpoint);
}

function getColors() {
  let endpoint = endpointConstants.YODAIDENTITY.GET_COLORS;
  return get(endpoint);
}
